import { render } from "./SilderMultipurpose.vue?vue&type=template&id=006cdb3e"
import script from "./SilderMultipurpose.vue?vue&type=script&lang=js"
export * from "./SilderMultipurpose.vue?vue&type=script&lang=js"

import "./SilderMultipurpose.vue?vue&type=style&index=0&id=006cdb3e&lang=css"

import exportComponent from "/Users/daniel/Documents/CETECREA/cetecrea/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__